import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StatsSection } from '../components/StatsSection';
import { ServicesSection } from '../components/ServicesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactCTASection } from '../components/ContactCTASection';
import { useLanguage, usePageMeta } from '../context/LanguageContext';
export function Home() {
  const {
    t
  } = useLanguage();
  usePageMeta(t.meta.home.title, t.meta.home.description);
  return <>
      <HeroSection data-id="element-220" />
      <StatsSection data-id="element-221" />
      <ServicesSection data-id="element-222" />
      <TestimonialsSection data-id="element-223" />
      <ContactCTASection data-id="element-224" />
    </>;
}